import axios from 'axios'
import { Url } from './constantUrl'
import getHeaders from './getHeaders'
import getHeadersformdata from './getHeaderFormdata'
import * as types from './types'
import { errorHandler } from './error/errorHandler.action'
import { notify } from '../services/notification'


//Change Password Post API
export const changePasswordAction = (params = {}) => dispatch => {
    const url = process.env.REACT_APP_API_URL + Url.CHANGE_PASSWORD
    let options = Object.assign({ method: 'POST' }, params ? { data: params } : null)
    options.headers = getHeadersformdata()
    options.url = url
    return axios(options).then(resp => {
      if (resp.status === 200 || resp.status === 201) {
        dispatch({ type: types.POST_CHANGE_PASSWORD, payload: resp })
        return resp
      } else { return null }
    }).catch(error => {
        if (error?.response?.status === 400||error?.response?.status === 403) {
            const errorMessage = error.response.data.error||error.response.data.Message;
            if(errorMessage){
              notify.error(errorMessage);
            }else{
              errorHandler(error)
            }
        }
    })
  }


  //Forgot Password Post API
export const forgotPasswordAction = (params = {}) => dispatch => {
    const url = process.env.REACT_APP_API_URL + Url.FORGET_PASSWORD
    let options = Object.assign({ method: 'POST' }, params ? { data: params } : null)
    options.url = url
    return axios(options).then(resp => {
      if (resp.status === 200 || resp.status === 201) {
        dispatch({ type: types.POST_FORGET_PASSWORD, payload: resp })
        return resp
      } else { return null }
    }).catch(error => {
      if (error?.response?.status === 400) {
        const errorMessage = error.response.data.error;
        if(errorMessage){
          notify.error(errorMessage);
        }else{
          errorHandler(error)
        }
    }
    })
  }

  //Verify Forgot Password OTP API
export const verifyForgotPasswordOtp = (params = {}) => dispatch => {
    const url = process.env.REACT_APP_API_URL + Url.VERIFY_FORGOT_PASSWORD_OTP
    let options = Object.assign({ method: 'POST' }, params ? { data: params } : null)
    options.url = url
    return axios(options).then(resp => {
      if (resp.status === 200 || resp.status === 201) {
        return resp
      } else { return null }
    }).catch(error => {
      if (error?.response?.status === 400) {
        const errorMessage = error.response.data.error || error.response.data.message;
        if(errorMessage){
          notify.error(errorMessage);
        }else{
          errorHandler(error)
        }
      } else if (error?.response?.status === 429) {
        notify.error(error.response.data?.message || 'Too many requests. Please try again later.');
      }
    })
  }

    //Reset Password Post API
export const resetPasswordAction = (params = {}, resetToken) => dispatch => {
    const url = process.env.REACT_APP_API_URL + Url.RESET_PASSWORD
    let options = Object.assign({ method: 'POST' }, params ? { data: params } : null)
    options.url = url
    if (resetToken) {
      options.headers = {
        "accept": "application/json",
        'Authorization': resetToken,
        'Access-Control-Allow-Origin': '*',
        "Content-Type": "application/json"
      }
    }
    return axios(options).then(resp => {
      if (resp.status === 200 || resp.status === 201) {
        dispatch({ type: types.POST_RESET_PASSWORD, payload: resp })
        return resp
      } else { return null }
    }).catch(error => {
      if (error?.response?.status === 400) {
        const errorMessage = error?.response?.data?.error;
        if(errorMessage?.new_password){
          notify.error(errorMessage?.new_password[0]);
        }
        else if(errorMessage){
          notify.error(errorMessage);
        }
        else{
          errorHandler(error)
        }
    }
    })
  }
